export const SET_NAVIGATED_ROUTE = "navigation/SET_NAVIGATED_ROUTE";
